import React from 'react';
import './App.css';
import ColorPicker from './colorPicker';

function App() {
  return (
    <div className="App">
      <ColorPicker />
    </div>
  );
}

export default App;
